import { schema } from "normalizr";

import { TranslatableMap } from "./localisation";
import { ApiModel } from "./model";

// Requests
interface RequestLogin {
    email: string;
    password: string;
}

// Responses
interface ResponseAuth {
    token_type: string;
    expires_in: number;
    access_token: string;
    refresh_token: string;
    user: User;
}

interface User extends ApiModel {
    kind: "user";
    // id: number; // id on parent
    name: string;
    email: string;
    created_at: Date;
    updated_at: Date;
    organisation: Organisation | number;
    roles: Role[] | number[];
    permissionsLevels?: {
        [key: number]: string;
    };
}

interface Organisation extends ApiModel {
    // id: number; // id on parent
    name: string;
    created_at: Date;
    updated_at: Date;
}

interface Role extends ApiModel {
    // id: number; // id on parent
    name: string;
    label: TranslatableMap;
    level: number;
    created_at: Date;
    updated_at: Date;
    permissions: Permission[] | number[];
}

interface Permission extends ApiModel {
    // id: number; // id on parent
    name: string;
    type: string;
    pivot: {
        level_name: string;
    };
}

// Define the normalized version of users and sub-classes.
const NPermission   = new schema.Entity("permissions");
const NRole         = new schema.Entity("roles", {
    permissions: [ NPermission ],
}, {
    idAttribute: "name",
});
const NOrganisation = new schema.Entity("organisations");
const NUser         = new schema.Entity("users", {
    organisation: NOrganisation,
    roles: [ NRole ],
});

interface AuthNormalisedEntities {
    organisations?: {
        [key: number]: Organisation;
    };
    permissions?: {
        [key: number]: Permission;
    };
    roles?: {
        [key: string]: Role;
    };
    users?: {
        [key: number]: User;
    };
}

export {
    RequestLogin,
    ResponseAuth,
    User,
    Organisation,
    Role,
    Permission,
    // Normalised data
    NUser,
    NOrganisation,
    NRole,
    NPermission,
    AuthNormalisedEntities,
};
